import { Switch as ChakraSwitch, Text } from '@chakra-ui/react';
import * as React from 'react';

type SwitchHiddenInputProps = React.ComponentPropsWithoutRef<'input'> &
  Partial<Record<`data-${string}`, string>>;

export interface SwitchProps extends ChakraSwitch.RootProps {
  /** Native input attributes (`name`, `readOnly`, `data-*`, etc.). Prefer top-level `aria-label` for accessible names. */
  inputProps?: SwitchHiddenInputProps;
  /** Ref on the outer `<label>`; `ref`/`forwardRef` targets the hidden input (for forms and libraries). */
  rootRef?: React.Ref<HTMLLabelElement>;
}

export const Switch = React.forwardRef<HTMLInputElement, SwitchProps>(function Switch(props, ref) {
  const { inputProps, children, rootRef, required, ...rest } = props;

  return (
    <ChakraSwitch.Root ref={rootRef} required={required} {...rest}>
      <ChakraSwitch.HiddenInput ref={ref} required={required} {...inputProps} />
      {children != null && (
        <ChakraSwitch.Label>
          {children}
          {required && (
            <>
              {' '}
              <Text asChild color="red.500">
                <span aria-hidden="true">*</span>
              </Text>
            </>
          )}
        </ChakraSwitch.Label>
      )}
      <ChakraSwitch.Control>
        <ChakraSwitch.Thumb />
      </ChakraSwitch.Control>
    </ChakraSwitch.Root>
  );
});
